export default __webpack_public_path__ + "static/media/LV.bce0f4cb.svg";